(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cielo-decoration-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.CieloDecorationContact) return;
    window.CieloDecorationContact = true;

    document.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = event.target instanceof Element ? event.target : event.target.parentElement;
      const trigger = target && target.closest('[data-cielo-interest]');
      if (!trigger) return;
      const interest = trigger.dataset.cieloInterest;
      if (!['filamento', 'decoracion', 'pieza'].includes(interest)) return;
      const section = document.getElementById('cielo-proyecto');
      const select = section && section.querySelector('select[name="contact[project_interest]"]');
      if (!select) return;
      event.preventDefault();
      select.value = interest;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      window.history.replaceState(window.history.state, '', '#cielo-proyecto');
      select.scrollIntoView({ block: 'center', behavior: 'auto' });
      select.focus({ preventScroll: true });
    });

    const initialize = () => {
      const feedback = document.querySelector('#cielo-proyecto [data-cdc-feedback]');
      if (!feedback || feedback.dataset.cdcFocused) return;
      feedback.dataset.cdcFocused = 'true';
      feedback.scrollIntoView({ block: 'center', behavior: 'auto' });
      feedback.focus({ preventScroll: true });
    };

    document.addEventListener('shopify:section:load', initialize);
    document.addEventListener('theme:section:load', initialize);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cielo-faq-us"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cielo-faq-us')) {
  class CieloFaqUs extends HTMLElement {
    connectedCallback() {
      this.initialize();
    }

    disconnectedCallback() {
      this.destroy();
    }

    initialize() {
      if (this.controller) return;
      this.searchInput = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-results]');
      this.status = this.querySelector('[data-status]');
      if (!this.searchInput || !this.results || !this.status) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.activeCategory = 'all';
      this.hadSearch = false;
      this.items = Array.from(this.querySelectorAll('[data-faq]')).map(element => ({
        element,
        category: element.dataset.category,
        search: this.normalize([
          element.querySelector('[data-question]')?.textContent || '',
          element.querySelector('[data-answer-content]')?.textContent || '',
          element.dataset.keywords || ''
        ].join(' '))
      }));
      this.groups = Array.from(this.querySelectorAll('[data-category-group]'));
      this.categoryLinks = Array.from(this.querySelectorAll('[data-category-filter]'));
      this.clearButton = this.querySelector('[data-cfaq-action="clear-search"]');
      this.resetButton = this.querySelector('[data-reset]');
      this.emptyState = this.querySelector('[data-empty]');
      this.expandButton = this.querySelector('[data-cfaq-action="expand"]');
      this.collapseButton = this.querySelector('[data-cfaq-action="collapse"]');
      this.searchInput.disabled = false;
      this.querySelectorAll('[data-enhanced]').forEach(element => { element.hidden = false; });
      this.searchInput.addEventListener('input', () => this.render(true), { signal });
      this.searchInput.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.searchInput.value) {
          event.preventDefault();
          this.clearSearch();
        }
      }, { signal });
      this.addEventListener('click', event => this.handleClick(event), { signal });
      window.addEventListener('hashchange', () => this.openFromHash(), { signal });
      this.setAttribute('data-ready', '');
      this.render(false);
      this.openFromHash();
    }

    destroy() {
      if (this.controller) this.controller.abort();
      this.controller = null;
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    normalize(value) {
      return String(value).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/ß/g, 'ss').replace(/œ/g, 'oe').replace(/æ/g, 'ae').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    }

    render(openSearchMatches) {
      const tokens = this.normalize(this.searchInput.value).split(/\s+/).filter(Boolean);
      const searching = tokens.length > 0;
      let visibleCount = 0;
      this.items.forEach(item => {
        const categoryMatches = this.activeCategory === 'all' || item.category === this.activeCategory;
        const visible = categoryMatches && tokens.every(token => item.search.includes(token));
        item.element.hidden = !visible;
        if (visible) visibleCount += 1;
        if (searching && openSearchMatches) item.element.open = visible;
        if (!searching && this.hadSearch) item.element.open = false;
      });
      this.groups.forEach(group => {
        group.hidden = !this.items.some(item => item.category === group.dataset.categoryGroup && !item.element.hidden);
      });
      this.categoryLinks.forEach(link => {
        const selected = link.dataset.categoryFilter === this.activeCategory;
        link.classList.toggle('is-active', selected);
        if (selected) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      this.status.textContent = this.dataset.resultsTemplate.replace('__shown__', String(visibleCount)).replace('__total__', String(this.items.length));
      this.clearButton.hidden = !this.searchInput.value;
      this.resetButton.hidden = this.activeCategory === 'all' && !this.searchInput.value;
      this.emptyState.hidden = visibleCount !== 0;
      this.expandButton.disabled = visibleCount === 0;
      this.collapseButton.disabled = visibleCount === 0;
      this.hadSearch = searching;
    }

    handleClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const quickLink = target.closest('[data-quick-search]');
      if (quickLink && this.contains(quickLink)) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.activeCategory = 'all';
        this.searchInput.value = quickLink.dataset.quickSearch;
        this.render(true);
        this.scrollToResults();
        return;
      }
      const categoryLink = target.closest('[data-category-filter]');
      if (categoryLink && this.contains(categoryLink)) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.activeCategory = categoryLink.dataset.categoryFilter;
        this.render(true);
        this.scrollToResults();
        return;
      }
      const control = target.closest('[data-cfaq-action]');
      if (!control || !this.contains(control)) return;
      const action = control.dataset.cfaqAction;
      if (action === 'clear-search') this.clearSearch();
      if (action === 'reset') {
        this.activeCategory = 'all';
        this.searchInput.value = '';
        this.render(false);
        this.searchInput.focus({ preventScroll: true });
      }
      if (action === 'expand' || action === 'collapse') {
        this.items.forEach(item => {
          if (!item.element.hidden) item.element.open = action === 'expand';
        });
      }
    }

    clearSearch() {
      this.searchInput.value = '';
      this.render(false);
      this.searchInput.focus({ preventScroll: true });
    }

    scrollToResults() {
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.results.scrollIntoView({ block: 'start', behavior });
    }

    openFromHash() {
      if (!this.items) return;
      const hash = window.location.hash.slice(1);
      if (/^faq-\d{2}$/.test(hash)) {
        const match = this.items.find(item => item.element.id === hash);
        if (!match) return;
        if (match.element.hidden) {
          this.activeCategory = 'all';
          this.searchInput.value = '';
          this.render(false);
        }
        match.element.open = true;
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          match.element.scrollIntoView({ block: 'start', behavior: 'auto' });
          match.element.querySelector('summary').focus({ preventScroll: true });
        });
        return;
      }
      const group = this.groups.find(element => element.id === hash);
      if (group) {
        this.activeCategory = group.dataset.categoryGroup;
        this.searchInput.value = '';
        this.render(false);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (this.isConnected) group.scrollIntoView({ block: 'start', behavior: 'auto' });
        });
      }
    }
  }

  customElements.define('cielo-faq-us', CieloFaqUs);
  const sectionFaqs = target => {
    if (!(target instanceof Element)) return [];
    const elements = Array.from(target.querySelectorAll('cielo-faq-us'));
    if (target.matches('cielo-faq-us')) elements.unshift(target);
    return elements;
  };
  document.addEventListener('shopify:section:load', event => {
    sectionFaqs(event.target).forEach(element => element.initialize());
  });
  document.addEventListener('shopify:section:unload', event => {
    sectionFaqs(event.target).forEach(element => element.destroy());
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cielo-projects-portfolio"] && !Shopify.designMode) return;
  try {
    
(() => {
  const elementName = 'cielo-projects-portfolio';
  if (customElements.get(elementName)) return;

  class CieloProjectsPortfolio extends HTMLElement {
    constructor() {
      super();
      this.frame = null;
      this.controller = null;
      this.returnFocus = null;
      this.activeProject = null;
      this.photoIndex = 0;
      this.backdropPointer = false;
    }

    connectedCallback() {
      if (this.frame !== null || this.controller) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (this.isConnected) this.initialize();
      });
    }

    disconnectedCallback() {
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.controller?.abort();
      this.controller = null;
      this.returnFocus = null;
      this.activeProject = null;
      if (this.dialog?.open) this.dialog.close();
    }

    initialize() {
      const source = this.querySelector('script[data-cp-media]');
      if (!source) return;
      let payload;
      try {
        payload = JSON.parse(source.textContent);
      } catch {
        return;
      }
      if (!Array.isArray(payload.projects)) return;

      this.projects = new Map(payload.projects
        .filter(project => typeof project.id === 'string' && Array.isArray(project.photos))
        .map(project => [project.id, {
          id: project.id,
          photos: project.photos.filter(photo => typeof photo.src === 'string' && photo.src.length > 0)
        }]));
      this.ui = payload.ui || {};
      this.templates = new Map([...this.querySelectorAll('template[data-case]')]
        .map(template => [template.dataset.case, template]));
      this.cards = [...this.querySelectorAll('.cp-card[data-project-id]')];
      this.filters = [...this.querySelectorAll('[data-filter]')];
      this.counts = [...this.querySelectorAll('[data-count]')];
      this.dialog = this.querySelector('[data-dialog]');
      this.caseCopy = this.querySelector('[data-case-copy]');
      this.galleryImage = this.querySelector('[data-gallery-image]');
      this.galleryCount = this.querySelector('[data-gallery-count]');
      this.galleryThumbs = this.querySelector('[data-gallery-thumbs]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.closeButton = this.querySelector('[data-close]');
      if (!this.dialog || !this.caseCopy || !this.galleryImage || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.addEventListener('click', event => this.handleClick(event), options);
      this.addEventListener('keydown', event => this.handleKeydown(event), options);
      this.dialog?.addEventListener('pointerdown', event => {
        this.backdropPointer = event.target === this.dialog && this.outsideDialog(event);
      }, options);
      this.dialog?.addEventListener('close', () => this.restoreFocus(), options);

      for (const count of this.counts) {
        count.setAttribute('role', 'status');
        count.setAttribute('aria-live', 'polite');
        count.setAttribute('aria-atomic', 'true');
      }
      if (this.galleryCount) {
        this.galleryCount.setAttribute('role', 'status');
        this.galleryCount.setAttribute('aria-live', 'polite');
        this.galleryCount.setAttribute('aria-atomic', 'true');
      }
      for (const [button, label] of [[this.previous, this.ui.previous], [this.next, this.ui.next], [this.closeButton, this.ui.close]]) {
        if (button && label) button.setAttribute('aria-label', label);
      }
      for (const thumbs of this.querySelectorAll('.cp-card-thumbs')) {
        thumbs.hidden = !thumbs.querySelector('[data-open]');
      }
      for (const trigger of this.querySelectorAll('[data-open]')) {
        trigger.setAttribute('aria-haspopup', 'dialog');
      }
      this.setFilter('all');
      this.dataset.enhanced = 'true';
    }

    handleClick(event) {
      if (!(event.target instanceof Element)) return;
      if (event.target === this.dialog) {
        if (this.backdropPointer && this.outsideDialog(event)) this.closeDialog();
        this.backdropPointer = false;
        return;
      }
      const control = event.target.closest('[data-filter], [data-open], [data-close], [data-previous], [data-next], [data-gallery-photo]');
      if (!control || !this.contains(control)) return;
      if (control.tagName === 'A' && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) return;

      if (control.hasAttribute('data-filter')) {
        event.preventDefault();
        this.setFilter(control.dataset.filter);
      } else if (control.hasAttribute('data-open')) {
        const opened = this.openProject(control.dataset.open, Number.parseInt(control.dataset.photo || '0', 10), control);
        if (opened) event.preventDefault();
      } else if (control.hasAttribute('data-close')) {
        event.preventDefault();
        this.closeDialog();
      } else if (control.hasAttribute('data-previous')) {
        event.preventDefault();
        this.showPhoto(this.photoIndex - 1);
      } else if (control.hasAttribute('data-next')) {
        event.preventDefault();
        this.showPhoto(this.photoIndex + 1);
      } else if (control.hasAttribute('data-gallery-photo')) {
        event.preventDefault();
        this.showPhoto(Number.parseInt(control.dataset.galleryPhoto, 10));
      }
    }

    handleKeydown(event) {
      if (!this.dialog?.open || event.ctrlKey || event.metaKey || event.altKey) return;
      if (event.target instanceof Element && event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        this.showPhoto(this.photoIndex + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    }

    setFilter(value) {
      const filter = value || 'all';
      let visible = 0;
      for (const card of this.cards) {
        const categories = (card.dataset.category || '').trim().split(/\s+/);
        card.hidden = filter !== 'all' && !categories.includes(filter);
        if (!card.hidden) visible += 1;
      }
      for (const button of this.filters) {
        button.setAttribute('aria-pressed', String(button.dataset.filter === filter));
      }
      for (const count of this.counts) {
        const label = visible === 1 ? count.dataset.labelOne : count.dataset.labelMany;
        count.textContent = label ? `${visible} ${label}` : String(visible);
      }
    }

    openProject(id, index, trigger) {
      const project = this.projects.get(id);
      const template = this.templates.get(id);
      if (!project?.photos.length || !template || !this.dialog || !this.caseCopy || !this.galleryImage || typeof this.dialog.showModal !== 'function') return false;

      this.caseCopy.replaceChildren(template.content.cloneNode(true));
      const title = this.caseCopy.querySelector('h2');
      if (title) {
        title.id = 'cp-case-title';
        this.dialog.setAttribute('aria-labelledby', title.id);
      }
      this.activeProject = project;
      this.returnFocus = trigger;
      this.dialog.dataset.projectId = id;
      this.dialog.dataset.singlePhoto = String(project.photos.length === 1);
      const single = project.photos.length === 1;
      if (this.previous) this.previous.hidden = single;
      if (this.next) this.next.hidden = single;
      this.renderThumbnails();
      const first = Number.isFinite(index) ? Math.min(Math.max(index, 0), project.photos.length - 1) : 0;
      try {
        if (!this.dialog.open) this.dialog.showModal();
      } catch {
        this.returnFocus = null;
        return false;
      }
      this.showPhoto(first);
      this.dialog.scrollTop = 0;
      this.closeButton?.focus({ preventScroll: true });
      return true;
    }

    renderThumbnails() {
      if (!this.galleryThumbs || !this.activeProject) return;
      this.galleryThumbs.replaceChildren();
      this.galleryThumbs.hidden = this.activeProject.photos.length < 2;
      if (this.galleryThumbs.hidden) return;
      const fragment = this.ownerDocument.createDocumentFragment();
      this.activeProject.photos.forEach((photo, index) => {
        const button = this.ownerDocument.createElement('button');
        button.type = 'button';
        button.dataset.galleryPhoto = String(index);
        button.setAttribute('aria-label', [this.ui.view_image || this.ui.photo, index + 1].filter(value => value !== undefined && value !== '').join(' '));
        button.setAttribute('aria-pressed', 'false');
        const img = this.ownerDocument.createElement('img');
        img.src = photo.thumb || photo.src;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.width = 152;
        img.height = 114;
        button.append(img);
        fragment.append(button);
      });
      this.galleryThumbs.append(fragment);
    }

    photoLabel(index, prefix) {
      const total = this.activeProject?.photos.length || 0;
      return [prefix || this.ui.photo, index + 1, this.ui.of || '/', total].filter(value => value !== undefined && value !== '').join(' ');
    }

    showPhoto(index) {
      if (!this.activeProject?.photos.length || !this.galleryImage || !Number.isFinite(index)) return;
      const total = this.activeProject.photos.length;
      this.photoIndex = ((index % total) + total) % total;
      const photo = this.activeProject.photos[this.photoIndex];
      this.galleryImage.alt = photo.alt || '';
      for (const dimension of ['width', 'height']) {
        const value = Number(photo[dimension]);
        if (Number.isFinite(value) && value > 0) this.galleryImage.setAttribute(dimension, String(value));
        else this.galleryImage.removeAttribute(dimension);
      }
      this.galleryImage.decoding = 'async';
      this.galleryImage.loading = 'eager';
      this.galleryImage.src = photo.src;
      if (this.galleryCount) this.galleryCount.textContent = this.photoLabel(this.photoIndex, this.ui.photo);
      if (!this.galleryThumbs) return;
      let active;
      for (const button of this.galleryThumbs.querySelectorAll('[data-gallery-photo]')) {
        const selected = Number(button.dataset.galleryPhoto) === this.photoIndex;
        button.setAttribute('aria-pressed', String(selected));
        if (selected) active = button;
      }
      if (active && !this.galleryThumbs.hidden) {
        const left = active.offsetLeft;
        const right = left + active.offsetWidth;
        if (left < this.galleryThumbs.scrollLeft) this.galleryThumbs.scrollLeft = left;
        else if (right > this.galleryThumbs.scrollLeft + this.galleryThumbs.clientWidth) {
          this.galleryThumbs.scrollLeft = right - this.galleryThumbs.clientWidth;
        }
      }
    }

    outsideDialog(event) {
      if (!this.dialog) return false;
      const bounds = this.dialog.getBoundingClientRect();
      return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
    }

    closeDialog() {
      if (this.dialog?.open) this.dialog.close();
    }

    restoreFocus() {
      const target = this.returnFocus;
      this.returnFocus = null;
      this.backdropPointer = false;
      if (!this.isConnected) return;
      if (target?.isConnected && !target.closest('[hidden]')) target.focus({ preventScroll: true });
      else this.filters.find(button => button.getAttribute('aria-pressed') === 'true')?.focus({ preventScroll: true });
    }
  }

  customElements.define(elementName, CieloProjectsPortfolio);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cielo-redes-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cielo-redes')) {
  class CieloRedes extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.gallery = this.querySelector('[data-gallery]');
      this.dialog = this.querySelector('[data-project-dialog]');
      if (!this.gallery || !this.dialog) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.projects = [...this.querySelectorAll('[data-project]')];
      this.filters = [...this.querySelectorAll('[data-filter]')];
      this.photos = [];
      this.photoIndex = 0;
      this.filters.forEach(button => {
        const category = button.dataset.filter;
        button.hidden = category !== 'all' && !this.projects.some(project => project.dataset.category === category);
        button.addEventListener('click', () => this.filterProjects(category), { signal });
      });
      this.querySelector('[data-gallery-tools]').hidden = false;
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-open-project]');
        if (!link || !this.contains(link) || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0 || typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        this.openProject(link);
      }, { signal });
      this.querySelector('[data-dialog-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.querySelector('[data-photo-prev]').addEventListener('click', () => this.changePhoto(-1), { signal });
      this.querySelector('[data-photo-next]').addEventListener('click', () => this.changePhoto(1), { signal });
      this.querySelector('[data-photo-retry]').addEventListener('click', () => this.renderPhoto(), { signal });
      this.dialog.addEventListener('keydown', event => {
        if (event.target.matches('input,textarea,select,[contenteditable]')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.changePhoto(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, { signal });
      this.dialog.addEventListener('click', event => {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.dialog.close();
      }, { signal });
      const media = this.querySelector('[data-dialog-media]');
      media.addEventListener('pointerdown', event => {
        this.swipeStart = event.pointerType === 'touch' || event.pointerType === 'pen' ? { x: event.clientX, y: event.clientY, id: event.pointerId } : null;
      }, { signal });
      media.addEventListener('pointerup', event => {
        const start = this.swipeStart;
        this.swipeStart = null;
        if (!start || start.id !== event.pointerId) return;
        const x = event.clientX - start.x;
        const y = event.clientY - start.y;
        if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.5) this.changePhoto(x < 0 ? 1 : -1);
      }, { signal });
      media.addEventListener('pointercancel', () => { this.swipeStart = null; }, { signal });
      this.dialog.addEventListener('close', () => {
        this.photoController?.abort();
        document.body.style.overflow = this.previousOverflow || '';
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, { signal });
    }
    filterProjects(category) {
      this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
      let count = 0;
      let photos = 0;
      this.projects.forEach(project => {
        const visible = category === 'all' || project.dataset.category === category;
        project.hidden = !visible;
        if (visible) {
          count++;
          photos += project.querySelectorAll('[data-open-project]').length;
        }
      });
      this.querySelector('[data-result-count]').textContent = this.dataset.galleryLabel.replace('[count]', String(count)).replace('[photos]', String(photos));
    }
    openProject(link) {
      const project = link.closest('[data-project]');
      if (!project) return;
      const links = [...project.querySelectorAll('[data-open-project]')];
      this.photos = links.map(photo => ({ src: photo.href, alt: photo.dataset.alt || photo.querySelector('img')?.alt || '', width: photo.dataset.width, height: photo.dataset.height }));
      if (!this.photos.length) return;
      this.opener = link;
      this.photoIndex = Math.max(0, links.indexOf(link));
      this.querySelector('[data-dialog-title]').textContent = project.dataset.projectTitle;
      this.querySelector('[data-dialog-location]').textContent = project.dataset.projectLocation;
      this.querySelector('[data-dialog-description]').textContent = project.dataset.projectDescription;
      this.querySelector('[data-dialog-controls]').hidden = this.photos.length < 2;
      this.renderPhoto();
      if (!this.dialog.open) {
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      }
      this.querySelector('[data-dialog-close]').focus({ preventScroll: true });
    }
    changePhoto(direction) {
      if (this.photos.length < 2) return;
      this.photoIndex = (this.photoIndex + direction + this.photos.length) % this.photos.length;
      this.renderPhoto();
    }
    renderPhoto() {
      const photo = this.photos[this.photoIndex];
      if (!photo) return;
      this.photoController?.abort();
      this.photoController = new AbortController();
      const signal = this.photoController.signal;
      const media = this.querySelector('[data-dialog-media]');
      const loading = this.querySelector('[data-photo-loading]');
      const error = this.querySelector('[data-photo-error]');
      const image = document.createElement('img');
      image.alt = photo.alt;
      image.width = Number(photo.width) || 1600;
      image.height = Number(photo.height) || 1200;
      image.decoding = 'async';
      image.hidden = true;
      loading.hidden = false;
      error.hidden = true;
      media.setAttribute('aria-busy', 'true');
      this.querySelector('[data-photo-source]').href = photo.src;
      const loaded = () => {
        if (signal.aborted) return;
        loading.hidden = true;
        error.hidden = true;
        image.hidden = false;
        media.setAttribute('aria-busy', 'false');
      };
      const failed = () => {
        if (signal.aborted) return;
        loading.hidden = true;
        error.hidden = false;
        image.hidden = true;
        media.setAttribute('aria-busy', 'false');
      };
      image.addEventListener('load', loaded, { once: true, signal });
      image.addEventListener('error', failed, { once: true, signal });
      media.replaceChildren(image);
      image.src = photo.src;
      if (image.complete) {
        if (image.naturalWidth) loaded();
        else failed();
      }
      this.querySelector('[data-photo-count]').textContent = this.dataset.photoLabel.replace('[current]', String(this.photoIndex + 1)).replace('[total]', String(this.photos.length));
    }
    disconnectedCallback() {
      this.photoController?.abort();
      if (this.dialog?.open) {
        document.body.style.overflow = this.previousOverflow || '';
        this.dialog.close();
      }
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('cielo-redes', CieloRedes);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cielo-visitanos-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cielo-visitanos')) {
    class CieloVisitanos extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.locations = [...this.querySelectorAll('[data-cv-location]')];
        this.filters = [...this.querySelectorAll('[data-cv-filter]')];
        const filterGroup = this.querySelector('[data-cv-filters]');
        if (filterGroup) filterGroup.hidden = false;
        this.filters.forEach(button => {
          const category = button.dataset.cvFilter;
          button.hidden = category !== 'all' && !this.locations.some(location => location.dataset.category === category);
          button.addEventListener('click', () => this.filterLocations(category), { signal });
        });
        this.addEventListener('click', event => {
          const choice = event.target.closest('[data-cv-select-photo]');
          if (!choice || !this.contains(choice) || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const gallery = choice.closest('[data-cv-gallery]');
          if (!gallery) return;
          const photos = [...gallery.querySelectorAll('[data-cv-photo]')];
          const index = Number(choice.dataset.cvSelectPhoto);
          if (!Number.isInteger(index) || !photos[index]) return;
          event.preventDefault();
          photos.forEach((photo, photoIndex) => { photo.hidden = photoIndex !== index; });
          gallery.querySelectorAll('[data-cv-select-photo]').forEach(link => {
            if (link === choice) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
          const status = gallery.querySelector('[data-cv-photo-count]');
          if (status) status.textContent = this.dataset.photoLabel.replace('[current]', String(index + 1)).replace('[total]', String(photos.length));
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const location = event.target.closest('[data-cv-location]');
          if (location && this.contains(location)) this.filterLocations('all');
        }, { signal });
        const feedback = this.querySelector('[data-cv-form-feedback]');
        if (feedback) feedback.focus({ preventScroll: false });
      }
      filterLocations(category) {
        let count = 0;
        this.locations.forEach(location => {
          const visible = category === 'all' || location.dataset.category === category;
          location.hidden = !visible;
          if (visible) count += 1;
        });
        this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.cvFilter === category)));
        const status = this.querySelector('[data-cv-count]');
        if (status) status.textContent = this.dataset.countLabel.replace('[count]', String(count));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    }
    customElements.define('cielo-visitanos', CieloVisitanos);
  }

  } catch(e) { console.error(e); }
})();
})();
